const getPromoTypeIdsBySport = (sportId?: string): number[] | null => {
    switch (sportId) {
        case 'esports_dota_2':
        case 'esports_league_of_legends':
        case 'esports_heroes_of_the_storm':
            return [50, 1, 20];

        case 'esports_counter_strike':
        case 'esports_rainbow_six':
            return [7, 1, 20];

        default:
            return null;
    }
};

export default getPromoTypeIdsBySport;
